import { ArchiveBoxIcon, SpeakerWaveIcon } from '@heroicons/react/24/outline';
import { PhotoIcon, PlayIcon } from '@heroicons/react/24/solid';
import { Tab, Tabs, useMediaQuery as useMediaQueryMUI } from '@mui/material';

function TopTabs({ tab, setTab }) {
  const isSmallMobile = useMediaQueryMUI((theme) =>
    theme?.breakpoints?.down('sm')
  );

  const tabs = [
    {
      label: 'All',
      value: 'all',
      icon: <ArchiveBoxIcon className="h-4 w-4 mr-1" />,
    },
    {
      label: 'Image',
      value: 'image',
      icon: <PhotoIcon className="h-4 w-4 mr-1" />,
    },
    {
      label: 'Video',
      value: 'video',
      icon: <PlayIcon className="h-4 w-4 mr-1" />,
    },
    {
      label: 'Audio',
      value: 'audio',
      icon: <SpeakerWaveIcon className="h-4 w-4 mr-1" />,
    },
  ];
  return (
    <Tabs
      value={tab}
      onChange={(_, v) => setTab(v)}
      textColor="primary"
      indicatorColor="primary"
    >
      {tabs.map((t) => (
        <Tab
          key={t.value}
          value={t.value}
          label={t.label}
          icon={t.icon}
          iconPosition={isSmallMobile ? 'top' : 'start'}
          sx={{
            fontWeight: 600,
            minHeight: 36,
            height: 36,
            fontSize: isSmallMobile ? 12 : 14,
            padding: isSmallMobile ? '0 0' : '9px 16px',
          }}
        />
      ))}
    </Tabs>
  );
}

export default TopTabs;
